import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import * as moment from "moment";
import { Subscription } from "rxjs";
import { Adicional } from "src/app/models/Emisor/Adicional";
import { CertificacionPrecio } from "src/app/models/PlanesUsuario/CertificacionPrecio";
import { Cupon } from "src/app/models/PlanesUsuario/Cupon";
import { Plan } from "src/app/models/PlanesUsuario/Plan";
import { PlanUsuario } from "src/app/models/PlanesUsuario/PlanUsuario";
import { Resumen } from "src/app/models/PlanesUsuario/Resumen";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { PagoUsuarioService } from "src/app/services/pago-usuario.service";
import { PlanUsuarioService } from "src/app/services/planUsuario.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UsuarioService } from "src/app/services/usuario.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { AdicionalType } from "src/app/shared/models/AdicionalType.enum";
import { SessionUser } from "src/app/shared/models/sessionUser";
import { CertificadoCompraWizard } from "src/app/models/Emisor/EmisorWizardRequest";
import { CERT_PRECIOS } from 'src/app/components/configuracion-dte/mantenedor-certificados/config-certificados';
import { CertificadosDigitalesService } from "src/app/services/certificados-digitales.service";
import { PermissionService } from "src/app/services/permission.service";
import { SaldoSeleccion } from "src/app/models/Saldo/SaldoSeleccion";
import { SaldoFavorCalculo } from "../saldo-favor-bloque/saldo-favor-calculo";



@Component({
	selector: "app-resumen-bloque",
	templateUrl: "./resumen-bloque.component.html",
	styleUrls: ["./resumen-bloque.component.scss"],
})
export class ResumenBloqueComponent implements OnInit, OnDestroy, OnChanges  {
	public CERT_PRECIOS = CERT_PRECIOS; 
	public nmeses: number;
	public nmesesCorte: number;
	public nmesesAntiguo: number;
	public nmesesNuevo: number = 0;
	public tipoCertificacion: string;
	public formaPago: string;
	public codigoDescuento: string;
	public cupon: Cupon;
	public mensajeCupon: string;
	public resumenCuenta: Resumen;
	public isLoading = false;
	public pagado: boolean;
	public idEmisor = this.tokenStorage.getCompany();

	@Input() public type: string;
	@Input() public planSeleccionado: Plan;
	@Input() public certificaciones: CertificacionPrecio[] = [];
	@Input() public planUsuario: PlanUsuario;
	@Input() public resumenExtern: Resumen;
	@Input() public planes: Plan[];
	@Input() public planActualNuevo: Plan;
	@Input() public compraCertificado: CertificadoCompraWizard;
	@Input() public modalLoading: boolean = false;
	@Input() public resumenBorrador: Resumen | null = null;
	
	public user: SessionUser;
	public adicionalSinMensajePDF: Adicional = new Adicional(3000, false, false, AdicionalType.MensajeSimpleFacturaPDF);
	public adicionalAccesoDTERecibido: Adicional = new Adicional(4000, false, false, AdicionalType.Recibidos);
	public adicionalPayku: Adicional = new Adicional(0, false, false, AdicionalType.Payku);

	public planOriginal: Plan = null;
	public planNuevo: Plan = null;
	public fechaDesde: string;
	private calcSub!: Subscription;
	private cotizacionSub?: Subscription;
	public conPropocional: boolean = false;

	@Output() public actualizarResumen: EventEmitter<Resumen> = new EventEmitter<Resumen>();

	public get totalElegibleSaldo(): number {
		const neto = Number(this.resumenCuenta?.neto || 0);
		return Math.max(0, Math.floor(neto));
	}

	private get totalesConSaldo(): { neto: number; iva: number; total: number } {
		const saldo = this.resumenCuenta?.usarSaldoFavor
			? this.resumenCuenta.saldoAplicadoEsperado
			: 0;
		return SaldoFavorCalculo.totalesConDescuentoNeto(
			this.resumenCuenta?.neto || 0,
			saldo
		);
	}

	public get netoPagarConSaldo(): number {
		return this.totalesConSaldo.neto;
	}

	public get ivaPagarConSaldo(): number {
		return this.totalesConSaldo.iva;
	}

	public get totalPagarConSaldo(): number {
		return this.totalesConSaldo.total;
	}

	public actualizarSaldoFavor(seleccion: SaldoSeleccion): void {
		if (!this.resumenCuenta) return;
		this.resumenCuenta.usarSaldoFavor = seleccion.usarSaldoFavor;
		this.resumenCuenta.saldoAplicadoEsperado = seleccion.saldoAplicadoEsperado;
		this.actualizarResumen.emit(this.resumenCuenta);
	}
	constructor(private planUsuarioService: PlanUsuarioService, private pagoService: PagoUsuarioService, private localStorage: LocalStorageService, private tokenStorage: TokenStorageService, private utilitieService: UtilitiesService, private ref: ChangeDetectorRef,private certificadoService: CertificadosDigitalesService,public permissions: PermissionService) {
		this.user = this.tokenStorage.getUser() as SessionUser;
	}
	ngOnDestroy() {
		if(this.calcSub && this.calcSub != undefined) this.calcSub.unsubscribe();
		this.cotizacionSub?.unsubscribe();
	}
	ngOnInit(): void {
		this.calcSub = this.pagoService.triggerCalculations$.subscribe(() => {
			if (this.planSeleccionado && this.planSeleccionado.nombre.toLowerCase() == "independiente") {
				this.adicionalAccesoDTERecibido.readOnly = false;
				this.adicionalAccesoDTERecibido.message = "Valor: $4.000";
				this.adicionalAccesoDTERecibido.precio = 4000;
			}
			this.actualizarCalculos();
			this.ref.detectChanges();
		});
		this.initializeValues();
		if (this.planes != null) {
			this.planNuevo = this.planes.find((x) => x.nombre == this.planUsuario.nombrePlan && x.antiguedad == "Nuevo");
		}
		if (this.planUsuario.fechaCorte) {
			const fechaInicio = moment(this.fechaDesde);
			const fechaCorte = moment(this.planUsuario.fechaCorte);
			let diffMeses = fechaCorte.diff(fechaInicio, "months");
			this.nmesesCorte = diffMeses < 0 ? 0 : diffMeses;
		} else {
			this.nmesesCorte = 0;
		}
		if (this.nmesesCorte === 0 && this.type == "extend") {
			this.planSeleccionado = this.planNuevo;
		}
		if (!this.planUsuario.activo) {
			if (this.planUsuario.meses) this.nmeses = this.planUsuario.meses;
			if (this.planUsuario.formaPago == "free") {
				this.formaPago = "webpay";
				this.updateCertificacion("propia");
			}
		}
		// Regla comercial: el primer pago de una empresa nunca aplica proporcional.
		// "Primer pago" = wizard (alta de empresa) o PlanUsuario actual aún en demo.
		// Una vez que la empresa pasó de demo a pagado, las renovaciones (extend) y
		// cambios de plan (change) sí aplican proporcional para ajustar a fin de mes.
		// El backend es la fuente de verdad; esta condición sólo alinea la previsualización.
		const esPrimerPagoEmpresa =
			this.type == "wizard" ||
			this.planUsuario?.isDemo === true;

		this.conPropocional = esPrimerPagoEmpresa ? false : this.user.configured;
		this.user = this.tokenStorage.getUser() as SessionUser;
		this.aplicarResumenBorrador(this.resumenBorrador);
	}
	ngOnChanges(changes: SimpleChanges): void {
		if (changes["planSeleccionado"] && !this.planOriginal) {
			this.planOriginal = changes["planSeleccionado"].currentValue;
		}
		if (changes["compraCertificado"] && changes["compraCertificado"].currentValue) {
			if (this.compraCertificado && this.compraCertificado.comprar) {
			  this.recalcularPrecioCertificado();
			  this.actualizarCalculos();
			}
		  }

		if (changes['resumenExtern'] && changes['resumenExtern'].currentValue) {
			this.resumenCuenta = changes['resumenExtern'].currentValue as Resumen;
			this.ref.detectChanges();
		}
		if (changes['resumenBorrador'] && changes['resumenBorrador'].currentValue && !changes['resumenBorrador'].isFirstChange()) {
			this.aplicarResumenBorrador(changes['resumenBorrador'].currentValue as Resumen);
		}
	}

	private aplicarResumenBorrador(resumen: Resumen | null): void {
		if (!resumen) {
			return;
		}
		if (resumen.meses) {
			this.nmeses = resumen.meses;
			this.calculoMeses();
		}
		(resumen.adicionales ?? []).forEach((adicionalGuardado) => {
			const destino = [this.adicionalSinMensajePDF, this.adicionalAccesoDTERecibido, this.adicionalPayku]
				.find((adicional) => adicional.idAdicional === adicionalGuardado.idAdicional);
			if (destino) {
				destino.checked = adicionalGuardado.checked;
			}
		});
		if (resumen.formaPago) {
			this.updateFormaPago(resumen.formaPago);
		} else {
			this.actualizarCalculos();
		}
	}
	calculateMeses(): void {
		if (this.type !== "extend") {
			this.nmesesNuevo = 0;
			this.nmesesAntiguo = this.nmeses;
			return;
		}
    
		if (this.nmesesCorte === 0) {
			this.nmesesAntiguo = this.nmeses;
			this.nmesesNuevo = 0;
		} else if (this.nmeses <= this.nmesesCorte) {
			this.nmesesAntiguo = this.nmeses;
			this.nmesesNuevo = 0;
		} else {
			this.nmesesAntiguo = this.nmesesCorte;
			this.nmesesNuevo = this.nmeses - this.nmesesCorte;
		}
	}
	initializeValues(): void {
		this.nmeses = 6;
		this.tipoCertificacion = "incluida";
		this.formaPago = "webpay";
		this.pagado = false;
		this.codigoDescuento = "";
		this.resumenCuenta = new Resumen();
		// No tocar precios ni estados cuando estamos en el flujo independiente de compra de certificaciones
		if (this.type !== 'certifications') {
			this.setCertFactAndCertBolToZero();
			this.checkCertFactAndCertBolToZero();
		}
		if (this.certificaciones && this.certificaciones.every((x) => x.solicitada === false)) {
			this.tipoCertificacion = "propia";
		}
		if (this.type == "extend" || this.type == "change") this.tipoCertificacion = "propia";

		if (this.type != "extend") {
			const adicionalSinMensajePDF = this.localStorage.getAdicionales().find((x) => x.idAdicional == AdicionalType.MensajeSimpleFacturaPDF);
			const adicionalAccesoDTERecibido = this.localStorage.getAdicionales().find((x) => x.idAdicional == AdicionalType.Recibidos);
			const adicionalPayku = this.localStorage.getAdicionales().find((x) => x.idAdicional == AdicionalType.Payku);

			if (adicionalSinMensajePDF) this.adicionalSinMensajePDF = adicionalSinMensajePDF;
			else {
				this.adicionalSinMensajePDF.idEmisor = this.idEmisor;
				this.adicionalSinMensajePDF.descripcion = "En el pie de página de los PDF de los DTE, se oculta el mensaje indicando que se realizó con SimpleFactura.";
			}
			if (adicionalAccesoDTERecibido) this.adicionalAccesoDTERecibido = adicionalAccesoDTERecibido;
			else {
				this.adicionalAccesoDTERecibido.idEmisor = this.idEmisor;
				this.adicionalAccesoDTERecibido.descripcion = "Módulo de Documentos emitidos por proveedores.";
			}
			this.adicionalPayku.idEmisor = this.idEmisor;
			this.adicionalPayku.descripcion = "Integración con Payku para pagos en línea.";
			this.adicionalPayku.message = "Sin costo adicional"
			
		} else {
			// En extensión se renuevan por defecto los adicionales ya contratados.
			// Desmarcar significa no renovarlos; no cancela su período ya pagado.
			const actuales = this.localStorage.getAdicionales() || [];
			const terminoActual = new Date(this.planUsuario.fechaCaducidad);
			const cargarParaRenovacion = (id: AdicionalType, fallback: Adicional) => {
				const existente = actuales.find((x) => x.idAdicional == id);
				if (!existente) return fallback;
				const inicio = existente.fechaInicio ? new Date(existente.fechaInicio) : null;
				const termino = existente.fechaTermino ? new Date(existente.fechaTermino) : null;
				// También incluye futuros que comienzan exactamente al vencer el plan actual (Payku).
				existente.checked = existente.checked && (!inicio || inicio <= terminoActual) &&
					(!termino || termino >= terminoActual);
				return existente;
			};
			this.adicionalSinMensajePDF = cargarParaRenovacion(AdicionalType.MensajeSimpleFacturaPDF, this.adicionalSinMensajePDF);
			this.adicionalAccesoDTERecibido = cargarParaRenovacion(AdicionalType.Recibidos, this.adicionalAccesoDTERecibido);
			this.adicionalPayku = cargarParaRenovacion(AdicionalType.Payku, this.adicionalPayku);
			[this.adicionalSinMensajePDF, this.adicionalAccesoDTERecibido, this.adicionalPayku]
				.forEach((adicional) => adicional.idEmisor = this.idEmisor);
		}
		this.fechaDesde =
			this.type == "wizard" || this.type == "change" || this.planUsuario.isDemo
				? new Date().toISOString()
				: new Date(this.planUsuario.fechaCaducidad).toISOString();
		// console.log("initializeValues");
		// this.actualizarCalculos();
		if (this.tipoCertificacion == "propia" && this.certificaciones && this.certificaciones.length && this.type !== 'certifications') {
			this.certificaciones.forEach((x) => (x.solicitada = false));
		}
	}

	updateCupon(codigo: string) {
		this.codigoDescuento = codigo;
		if (codigo.length > 0) {
			this.planUsuarioService.getCupon(this.codigoDescuento).subscribe(
				(data) => {
					this.cupon = data;
				},
				(error) => {
					this.mensajeCupon = this.utilitieService.setErrorMessageFromArray(error.error);
					this.cupon = undefined;
				},
				() => {
					this.actualizarCalculos();
				}
			);
		} else {
			this.cupon = undefined;
			this.actualizarCalculos();
		}
	}

	updateFormaPago(forma) {
		this.formaPago = forma;
		if (forma == "free") {
			this.limpiarAdicionalesDemoGratis();
			this.updateCertificacion("propia");
		} else {
			this.habilitarAdicionalesPago();
			this.actualizarCalculos();
		}
	}

	public esDemoGratis(): boolean {
		return this.formaPago === "free" && this.type !== "certifications";
	}

	private limpiarAdicionalesDemoGratis(): void {
		[this.adicionalSinMensajePDF, this.adicionalAccesoDTERecibido, this.adicionalPayku].forEach((adicional) => {
			adicional.checked = false;
			adicional.readOnly = true;
		});
	}

	private habilitarAdicionalesPago(): void {
		this.adicionalSinMensajePDF.readOnly = false;
		this.adicionalPayku.readOnly = false;
		if (this.planSeleccionado?.nombre?.toLowerCase() == "independiente") {
			this.adicionalAccesoDTERecibido.readOnly = false;
		}
	}
	public resetearAdicionalAccesoDTEPorCambioDePlan(plan: Plan): void {
		if (plan?.nombre?.toLowerCase() === "independiente") {
			this.adicionalAccesoDTERecibido.readOnly = false;
			this.adicionalAccesoDTERecibido.message = "Valor: $4.000";
			this.adicionalAccesoDTERecibido.precio = 4000;
			this.adicionalAccesoDTERecibido.checked = false;
		}
	}

	updateCertificacion(tipo) {
		this.tipoCertificacion = tipo;
		if (this.nmeses >= 6) {
			this.setCertFactAndCertBolToZero();
		}
		if (this.tipoCertificacion != "propia") {
			this.formaPago = "webpay";
		} else {
			this.certificaciones.forEach((x) => {
				x.solicitada = false;
			});
		}
		this.actualizarCalculos();
	}

	updateModelCertificacion(cert) {
		// Ignorar cambios mientras el resumen está cargando (trigger desde padre)
		if (this.modalLoading || this.isLoading) return;
		cert.solicitada = !cert.solicitada;
		this.actualizarCalculos();
	}

	updateMes(meses) {
		this.nmeses = meses;
		this.calculoMeses();
		this.actualizarCalculos();
	}

	actualizarCalculos() {
		let customResumen: any = null;
		if (this.esDemoGratis()) {
			// Guardamos el resumen personalizado
			customResumen = {
				proporcional: 0,
				totalPlanes: 0,
				totalAdicionales: 0,
				totalCertificaciones: 0,
				subtotal: 0,
				descuento: 0,
				descuentoPorc: 0,
				neto: 0,
				iva: 0,
				total: 0,
				totalCertificadoDigital: this.calcularTotalesCertificadoDigital(),
				formaPago: this.formaPago,
			};
		}
		if (this.planSeleccionado) {
			if (this.esDemoGratis()) {
				this.limpiarAdicionalesDemoGratis();
			}
			if (!this.esDemoGratis() && this.planSeleccionado.nombre.toLowerCase() != "independiente") {
				this.adicionalAccesoDTERecibido.readOnly = true;
				this.adicionalAccesoDTERecibido.checked = true;
				this.adicionalAccesoDTERecibido.precio = 0;
				this.adicionalAccesoDTERecibido.message = "Incluído con tu plan";
			} else if (!this.esDemoGratis() && this.adicionalAccesoDTERecibido.precio != 0) {
				this.adicionalAccesoDTERecibido.readOnly = false;
				this.adicionalAccesoDTERecibido.message = "Valor: $4.000";
				this.adicionalAccesoDTERecibido.precio = 4000;
			}
			this.ref.detectChanges();
			this.isLoading = true;

			this.calculateMeses();

			const totalCertificadoDigital = this.calcularTotalesCertificadoDigital();
			const adicionalesSolicitados = this.esDemoGratis()
				? []
				: [this.adicionalAccesoDTERecibido, this.adicionalSinMensajePDF, this.adicionalPayku];
			const usarSaldoFavor = this.resumenCuenta?.usarSaldoFavor ?? false;
			const saldoAplicadoEsperado = this.resumenCuenta?.saldoAplicadoEsperado ?? 0;
			this.cotizacionSub?.unsubscribe();
			this.cotizacionSub = this.planUsuarioService.cotizarPlan({
				idEmisor: this.idEmisor,
				idUsuario: this.user.id,
				idPlanSfNuevo: this.planSeleccionado.id,
				meses: this.nmeses,
				tipoCertificacion: this.tipoCertificacion,
				codigoCupon: this.codigoDescuento,
				totalCertificadoDigital,
				conProporcional: this.conPropocional,
				certificaciones: this.certificaciones,
				adicionales: adicionalesSolicitados,
				persistir: this.type !== "wizard"
			}).subscribe((cotizacion) => {
				const data: any = {
					cotizacionId: cotizacion.cotizacionId,
					tipoCambio: cotizacion.tipoCambio,
					permitido: cotizacion.permitido,
					motivoRechazo: cotizacion.motivoRechazo,
					abono: cotizacion.abono,
					mesesAbono: cotizacion.mesesAbono,
					proporcional: cotizacion.proporcional,
					descuento: cotizacion.descuento,
					descuentoPorc: cotizacion.descuentoPorc,
					neto: cotizacion.neto,
					iva: cotizacion.iva,
					total: cotizacion.total,
					subtotal: cotizacion.subtotal,
					totalPlanes: cotizacion.totalPlanes,
					totalCertificaciones: cotizacion.totalCertificaciones,
					totalAdicionales: cotizacion.totalAdicionales,
					fechaInicioProporcional: cotizacion.fechaInicioVigencia,
					fechaTermino: cotizacion.fechaTerminoVigencia,
					esReactivacion: cotizacion.esReactivacion,
					meses: cotizacion.meses,
					totalCertificadoDigital,
					formaPago: this.formaPago,
					idPlanSf: this.planSeleccionado.id,
					nombrePlan: this.planSeleccionado.nombre,
					adicionales: adicionalesSolicitados,
					extend: this.type == "extend",
					change: this.type == "change",
					codigoCupon: this.codigoDescuento,
					idPlanUsuario: this.planUsuario.idPlanUsuario,
					certificaciones: this.certificaciones,
					pagado: this.planUsuario.pagado,
					usarSaldoFavor: usarSaldoFavor,
					saldoAplicadoEsperado: usarSaldoFavor ? saldoAplicadoEsperado : 0,
				};
				this.calculoMeses();
				data.differenceInDays = this.calculoDiasDiferencia(data.fechaInicioProporcional, data.fechaTermino);
				this.resumenCuenta = data
				? { ...data, ...customResumen }
				: data;
				this.actualizarResumen.emit(this.resumenCuenta);
				this.ref.detectChanges();
				this.isLoading = false;
			});
		}
	}
	calculoDiasDiferencia(fechaInicioProporcional: any, fechaTermino: any): number {
		const fechaInicio = new Date(fechaInicioProporcional);
		const fechaFin = new Date(fechaTermino);

		if (!fechaInicio || !fechaFin || isNaN(fechaInicio.getTime()) || isNaN(fechaFin.getTime())) {
			return 0;
		}
		const fechaInicioSinHoras = new Date(fechaInicio.setHours(0, 0, 0, 0));
		const fechaTerminoSinHoras = new Date(fechaFin.setHours(0, 0, 0, 0));
		const diferenciaEnMilisegundos = fechaTerminoSinHoras.getTime() - fechaInicioSinHoras.getTime();
		const diferenciaEnDias = diferenciaEnMilisegundos / (1000 * 60 * 60 * 24);

		return diferenciaEnDias;
	}
	//aqui estan los cambios de luis Revisar con Backend ya que todo lo de los abonos y calculos se esta haciendo en el backend y no en el front,
	//El calcular que esta en la parte de arriba es el que se esta usando para calcular los totales y no el de abajo, solo falta la revision por lo que agrego el luis
	/*actualizarCalculos() {
		const isUpgrade = this.esUpgrade(this.planUsuario, this.planSeleccionado);

		let abono = 0;
		let mesesAbono = 0;
		let fechaInicioAbono: moment.Moment | null = null;
		let fechaTerminoAbono: moment.Moment | null = null;
		if (isUpgrade) {
			const fechaHoy = moment();
			const fechaFinPlan = moment(this.planUsuario.fechaCaducidad);
			const fechaCorte = this.planUsuario.fechaCorte ? moment(this.planUsuario.fechaCorte) : null;
			const resultado = this.calcularAbonoUpgrade(
				fechaHoy,
				fechaFinPlan,
				fechaCorte,
				this.planUsuario.pagoMensual,
				this.planActualNuevo.precio
			);
			abono = resultado.abono;
			mesesAbono = resultado.mesesAbono;
			fechaInicioAbono = resultado.fechaInicioAbono;
			fechaTerminoAbono = resultado.fechaTerminoAbono;
			// Forzar mínimo en el slider si es necesario
			if (this.nmeses < mesesAbono) {
				this.nmeses = mesesAbono;
			}
		}
		let customResumen: any = null;
		if (this.esDemoGratis()) {
			// Guardamos el resumen personalizado
			customResumen = {
				proporcional: 0,
				totalPlanes: 0,
				totalAdicionales: 0,
				totalCertificaciones: 0,
				subtotal: 0,
				descuento: 0,
				descuentoPorc: 0,
				neto: 0,
				iva: 0,
				total: 0,
				totalCertificadoDigital: this.calcularTotalesCertificadoDigital(),
				formaPago: this.formaPago,
			};
		}
		if (this.planSeleccionado) {
			if (this.esDemoGratis()) {
				this.limpiarAdicionalesDemoGratis();
			}
			if (!this.esDemoGratis() && this.planSeleccionado.nombre.toLowerCase() != "independiente") {
				this.adicionalAccesoDTERecibido.readOnly = true;
				this.adicionalAccesoDTERecibido.checked = true;
				this.adicionalAccesoDTERecibido.precio = 0;
				this.adicionalAccesoDTERecibido.message = "Incluído con tu plan";
			} else if (!this.esDemoGratis() && this.adicionalAccesoDTERecibido.precio != 0) {
				this.adicionalAccesoDTERecibido.readOnly = false;
				this.adicionalAccesoDTERecibido.message = "Valor: $4.000";
				this.adicionalAccesoDTERecibido.precio = 4000;
			}
			this.ref.detectChanges();
			this.isLoading = true;
			
			this.calculateMeses();
						
			const fechaDesde = this.type == 'wizard' || this.type == 'change' //|| this.planUsuario.formaPago == 'free'
			? new Date().toISOString() 
			: new Date(this.planUsuario.fechaCaducidad).toISOString();
			const totalCertificadoDigital = this.calcularTotalesCertificadoDigital();
			// Payku es gratuito: recalcular sus checks no debe borrar una selección de saldo ya vigente.
			const usarSaldoFavor = this.resumenCuenta?.usarSaldoFavor ?? false;
			const saldoAplicadoEsperado = this.resumenCuenta?.saldoAplicadoEsperado ?? 0;
			this.planUsuarioService.getCalculos(this.planSeleccionado.id, this.nmesesAntiguo, this.tipoCertificacion, this.codigoDescuento, 
				this.certificaciones, this.adicionalAccesoDTERecibido, this.adicionalSinMensajePDF, this.fechaDesde, 
				this.conPropocional,this.planNuevo ? this.planNuevo.id : null, this.nmesesNuevo,
				totalCertificadoDigital, abono, this.adicionalPayku
			).subscribe((data) => {
				if (isUpgrade) {
					data.abono = abono;
					data.mesesAbono = mesesAbono;
					data.fechaInicioAbono = fechaInicioAbono;
					data.fechaTerminoAbono = fechaTerminoAbono;
					data.descripcionAbono =
					`Se consideró $${abono.toLocaleString('es')} como abono por el plan ${this.planUsuario.nombrePlan}`;
					data.idPlanUsuarioAntiguo = this.planUsuario.idPlanUsuario;
				}
				data.totalCertificadoDigital = totalCertificadoDigital;
				data.formaPago = this.formaPago;
				data.usarSaldoFavor = usarSaldoFavor;
				data.saldoAplicadoEsperado = usarSaldoFavor ? saldoAplicadoEsperado : 0;
				data.idPlanSf = this.planSeleccionado.id;
				data.nombrePlan = this.planSeleccionado.nombre;
				data.adicionales = this.esDemoGratis()
					? []
					: [this.adicionalAccesoDTERecibido, this.adicionalSinMensajePDF, this.adicionalPayku];
				//TODO: data.idPlanUsuario = this.idPlanUsuario;
				data.extend = this.type == "extend";
				data.change = this.type == "change";
				data.codigoCupon = this.codigoDescuento;
				//TODO: if (this.pagado == true) data.total = this.planUsuarioPagado.total;
				data.idPlanUsuario = this.planUsuario.idPlanUsuario;
				this.resumenCuenta = data;
				data.certificaciones = this.certificaciones;
				this.calculoMeses();
				data.pagado = this.planUsuario.pagado;
				data.differenceInDays = this.calculoDiasDiferencia(data.fechaInicioProporcional, data.fechaTermino);
				this.resumenCuenta = customResumen
				? { ...data, ...customResumen }
				: data;
				this.actualizarResumen.emit(this.resumenCuenta);
				this.ref.detectChanges();
				this.isLoading = false;
			});
		}
	}*/
	
	// calculoMeses() {
	// 	if (this.certificaciones && this.tipoCertificacion != "propia") {
	// 		if (this.nmeses == 0) this.nmeses = 6;
	// 		else if (this.nmeses >= 6) {
	// 			this.certificaciones.find((x) => x.codigoPrincipal == 33).valor = 0;
	// 			this.certificaciones.find((x) => x.codigoPrincipal == 39).valor = 0;
	// 			this.tipoCertificacion = "incluida";
	// 		} else {
	// 			this.certificaciones.find((x) => x.codigoPrincipal == 33).valor = 30000;
	// 			this.certificaciones.find((x) => x.codigoPrincipal == 39).valor = 15000;
	// 			this.tipoCertificacion = "agregar";
	// 		}
	// 	}
	// }
	get isIndependiente(): boolean {
		return this.planSeleccionado?.nombre?.toLowerCase() === "independiente";
	}

	calculoMeses() {
		if (!this.certificaciones || this.tipoCertificacion === "propia") {
			return;
		}

		if (this.isIndependiente) {
			// Lógica para planes "independiente"
			if (this.nmeses < 12) {
				// Menos de 12 meses
				this.certificaciones.find((x) => x.codigoPrincipal === 33).valor = 45000;
				this.certificaciones.find((x) => x.codigoPrincipal === 39).valor = 30000;
				this.tipoCertificacion = "agregar";
			} else {
				// 12 meses o más
				this.certificaciones.find((x) => x.codigoPrincipal === 33).valor = 0;
				this.certificaciones.find((x) => x.codigoPrincipal === 39).valor = 0;
				this.tipoCertificacion = "incluida";
			}
		} else {
			// Lógica para otros planes
			if (this.nmeses < 6) {
				// Menos de 6 meses
				this.certificaciones.find((x) => x.codigoPrincipal === 33).valor = 45000;
				this.certificaciones.find((x) => x.codigoPrincipal === 39).valor = 30000;
				this.tipoCertificacion = "agregar";
			} else {
				// 6 meses o más
				this.certificaciones.find((x) => x.codigoPrincipal === 33).valor = 0;
				this.certificaciones.find((x) => x.codigoPrincipal === 39).valor = 0;
				this.tipoCertificacion = "incluida";
			}
		}
	}

	setCertFactAndCertBolToZero(): void {
			// No sobrescribir precios cuando mostramos el modal específico de "certifications"
			if (this.type === 'certifications') return;
			if (this.certificaciones && this.certificaciones.length) {
				const certFact = this.certificaciones.find((x) => x.codigoPrincipal === 33);
				if (certFact) certFact.valor = 0;

				const certBol = this.certificaciones.find((x) => x.codigoPrincipal === 39);
				if (certBol) certBol.valor = 0;

				this.ref.detectChanges();
			}
	}

	checkCertFactAndCertBolToZero(): void {
		// En el flujo de compra de certificaciones no forzamos solicitudes automáticas
		if (this.type === 'certifications') return;
		if (this.certificaciones && this.certificaciones.length) {
			const certFact = this.certificaciones.find((x) => x.codigoPrincipal === 33);
			if (certFact) certFact.solicitada = true;

			const certBol = this.certificaciones.find((x) => x.codigoPrincipal === 39);
			if (certBol) certBol.solicitada = true;

			this.ref.detectChanges();
		}
	}

	onChangeDuracion(): void {      
		this.recalcularPrecioCertificado();
		this.actualizarCalculos();                    
	}
	  
	onCheckBoxGarantia(): void {
		this.recalcularPrecioCertificado();
		this.actualizarCalculos();
	}

	private recalcularPrecioCertificado(): void {
		const duracion = this.compraCertificado.duracion;
		const garantia = this.compraCertificado.garantia;

		if (!duracion) {
			this.compraCertificado.preciobase = 0;
			this.compraCertificado.precioGarantia = 0;
			this.compraCertificado.total = 0;
			return;
		}
		this.certificadoService.getTarifasCertificado().subscribe({
			next: (data) => {
				const precioCert = data.find(
					t => t.nombreProducto == "Certificado Digital"&& t.anios === duracion
				);
				const precioGarantia = data.find(
					t => t.nombreProducto.toLowerCase().includes('garantía') && t.anios === duracion
				);

				this.compraCertificado.preciobase = precioCert ? precioCert.precio : 0;
				this.compraCertificado.precioGarantia = (garantia && precioGarantia) ? precioGarantia.precio : 0;
				this.compraCertificado.total = this.compraCertificado.preciobase + this.compraCertificado.precioGarantia;
				this.ref.detectChanges();
				this.actualizarCalculos();
			},
			error: () => {
				this.compraCertificado.preciobase     = 0;
				this.compraCertificado.precioGarantia = 0;
				this.compraCertificado.total          = 0;
				this.ref.detectChanges();
				this.actualizarCalculos();
			}
		});
	}

	private calcularTotalesCertificadoDigital(): number {
		if (this.compraCertificado?.comprar) {
			const subtotal = (this.compraCertificado.preciobase || 0) + (this.compraCertificado.precioGarantia || 0);
			this.compraCertificado.total = Math.round(subtotal);
			return this.compraCertificado.total;
		}
		return 0;
	}

	public eliminarCertificadoDigital(): void {
		this.compraCertificado.comprar = false;
		this.compraCertificado.duracion = null;
		this.compraCertificado.garantia = false;
		this.compraCertificado.preciobase = 0;
		this.compraCertificado.precioGarantia = 0;
		this.compraCertificado.total = 0;
		this.actualizarCalculos();
	}

}
